import {DataObjectId, Hub} from 'yougile-model'
import {Accounts} from '@client/accounts'
import {Sync} from '@client/sync'
import {stickerCtl} from '@extensions/sticker/sticker'

export const sortByExecutorAz = (tasks: Hub[], column: Hub): Hub[] => {
  const userSticker = stickerCtl.User.getSticker(Sync.get(column))

  return tasks.sort((b, a) => {
    const aUserId = getUserId(a, userSticker.id)
    const bUserId = getUserId(b, userSticker.id)

    if (aUserId && bUserId) {
      const aTitle = getUserName(aUserId)
      const bTitle = getUserName(bUserId)
      return (bTitle || '').localeCompare(aTitle || '')
    }

    if (aUserId) {
      return 1
    }

    if (!aUserId && !bUserId) {
      return 0
    }

    return -1
  })
}

export const sortByExecutorZa = (tasks: Hub[], column: Hub): Hub[] => {
  const userSticker = stickerCtl.User.getSticker(Sync.get(column))

  return tasks.sort((b, a) => {
    const aUserId = getUserId(a, userSticker.id)
    const bUserId = getUserId(b, userSticker.id)

    if (aUserId && bUserId) {
      const aTitle = getUserName(aUserId)
      const bTitle = getUserName(bUserId)
      return (aTitle || '').localeCompare(bTitle || '')
    }

    if (aUserId) {
      return 1
    }

    if (!aUserId && !bUserId) {
      return 0
    }

    return -1
  })
}

const getUserId = (hub: Hub, userStickerId: DataObjectId): DataObjectId => {
  const data = hub.stickers[userStickerId]

  return Array.isArray(data) ? data[0] : data
}

const getUserName = (userId: DataObjectId): string => {
  const realName = Accounts.get(userId)?.realName || ''
  if (realName && realName !== '_') {
    return realName
  }

  const users = Sync.getCurrentSandbox().getAllUsers(false)
  const user = users.find(user => user.id === userId)
  return user.email || ''
}
